import { Component, OnInit, Inject, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HeaderComponent } from '../../headers/header/header.component';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from '../../footers/footer/footer.component';
import { SportFilterComponent } from '../../sport-filter/sport-filter.component';
import { NotificationComponent } from '../../util/notification/notification.component';
import { ConfirmModalComponent } from '../../util/confirm-modal/confirm-modal.component';
import { ImagePreviewComponent } from '../../util/image-preview/image-preview.component';
import { HeroOverlayService } from '../../../services/hero-overlay.service';

@Component({
  selector: 'app-layout',
  imports: [
    HeaderComponent,
    RouterOutlet,
    FooterComponent,
    SportFilterComponent,
    NotificationComponent,
    ConfirmModalComponent,
    ImagePreviewComponent,
  ],
  template: `
    <div
      class="h-screen w-screen flex flex-col default-theme overflow-x-hidden bg-background"
    >
      <main class="flex-1">
        <app-header></app-header>
        <!--
          The header is fixed, so it occupies no space in flow. Every page needs
          that space back except one running a full-bleed hero, which is meant
          to pass underneath it.
        -->
        <div [class.pt-16]="!overlay.heroActive()">
          <router-outlet></router-outlet>
        </div>
        <app-sport-filter></app-sport-filter>
        <app-notification></app-notification>
        <app-confirm-modal></app-confirm-modal>
      </main>
      <div class="flex-shrink-0">
        <app-footer></app-footer>
      </div>

      <app-image-preview></app-image-preview>

      <!-- Open in app button for mobile -->
      @if (isMobile) {
      <button
        (click)="openInApp()"
        class="fixed bottom-6 right-6 z-50 bg-secondary text-secondaryContrast px-4 py-2 rounded-full shadow-lg transition-colors"
      >
        Open in app
      </button>
      }
    </div>
  `,
  styles: ``,
})
export class LayoutComponent implements OnInit {
  readonly overlay = inject(HeroOverlayService);
  isMobile = false;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  ngOnInit() {
    this.detectMobile();
  }

  private detectMobile() {
    // Only run in browser
    if (isPlatformBrowser(this.platformId)) {
      this.isMobile =
        /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        );
    }
  }

  openInApp() {
    // Only run in browser
    if (!isPlatformBrowser(this.platformId)) return;
    
    const appScheme = 'com.sportilink.app://';
    const fallbackUrl = this.getAppStoreUrl();

    // Try to open the app
    window.location.href = appScheme;

    // Fallback to app store after a delay if app doesn't open
    setTimeout(() => {
      window.location.href = fallbackUrl;
    }, 2000);
  }

  private getAppStoreUrl(): string {
    // Only run in browser
    if (!isPlatformBrowser(this.platformId)) return '';
    
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    if (isIOS) {
      return 'https://apps.apple.com/id/app/sportilink/id6742344195';
    } else {
      return 'https://play.google.com/store/apps/details?id=com.sportilink.app';
    }
  }
}
